export const TIERS = { CORE: 'Core', ADVANCED: 'Advanced' };

export const EMPTY_TENANT_MODEL = {
  tier: '',
  addOns: [],
  tenantId: '',
};
